import { render, staticRenderFns } from "./Porsche.vue?vue&type=template&id=7a0c2a64&scoped=true"
import script from "./Porsche.vue?vue&type=script&lang=js"
export * from "./Porsche.vue?vue&type=script&lang=js"
import style0 from "./Porsche.vue?vue&type=style&index=0&id=7a0c2a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0c2a64",
  null
  
)

export default component.exports